<template>
  <div class="course-bulking-options inline-replacement">
    <weui-group type="checkbox">
      <weui-checkbox v-for="o in options" :key="o.id" v-model="o.checked">
        <p :class="{ 'text-primary': draftOptions.indexOf(o.id) >= 0 }">{{ o.name }}</p>
      </weui-checkbox>
    </weui-group>
    <weui-button-area>
      <weui-button type="primary" @click="saveOptions">设置</weui-button>
    </weui-button-area>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { WeuiGroup, WeuiCheckbox, WeuiButtonArea, WeuiButton } from '@/components/weui';

import PROGRAMS, { PROGRAM_BULKING } from '@/constants/programs';
import { COURSE_DRAFT_FILL } from '@/store/course/types';

const { mapState, mapMutations } = createNamespacedHelpers('course');

export default {
    data() {
        const bulking = PROGRAMS.find(p => p.id === PROGRAM_BULKING);
        const options = bulking.options.map(opt => ({
            ...opt,
            checked: false,
        }));

        return {
            bulking,
            options,
        };
    },
    computed: {
        ...mapState({
            draft: state => state.draft,
        }),
        draftOptions() {
            return this.draft.program_options[PROGRAM_BULKING] || [];
        },
    },
    mounted() {
        this.draftOptions.forEach((oid) => {
            const option = this.options.find(o => o.id === oid);
            if (option) {
                option.checked = true;
            }
        });
    },
    methods: {
        ...mapMutations({
            fillDraft: COURSE_DRAFT_FILL,
        }),
        saveOptions() {
            const options = this.options.filter(o => o.checked).map(o => o.id);

            this.fillDraft({
                program_options: {
                    ...this.draftOptions,
                    [PROGRAM_BULKING]: options,
                },
            });
            this.$router.go(-1);
        },
    },
    components: {
        WeuiGroup,
        WeuiCheckbox,
        WeuiButtonArea,
        WeuiButton,
    },
};
</script>



// WEBPACK FOOTER //
// src/containers/course/BulkingOptions.vue